import {
    FilterParam,
    PageableParam,
    SortParam, useGetCustomerGroupsQuery, useGetProcessLogsQuery, useGetTenantsQuery,
    useRacksQuery,
    useStorageEntriesQuery,
    useZonesQuery
} from '../api/models'
import { useBoxtypes } from "./dataService";

export const getContext = (token: string | undefined) => {
    return {
        headers: {
            Authorization: `Bearer ${token || 'unknown'}`,
        },
    }
}

interface useStorageEntriesProps {
    pagination: PageableParam
    sort: SortParam[]
    q: string | null
    filter: FilterParam[]
}

export const createBaseContext = (token: string, variables: any = {}) => {
    return { context: getContext(token), variables }
}

export const useStorageEntries = (token: string | undefined, params: useStorageEntriesProps) => {
    const { pagination, sort, q, filter } = params
    return useStorageEntriesQuery({ context: getContext(token), variables: { pagination, sort, q, filter } })
}

export const useZones = (token: string | undefined, params: { q?: string }) => {
    const { q } = params
    return useZonesQuery({ context: getContext(token), variables: { q } })
}

export const useProcessLogs = (token: string | undefined, params: { q?: string, pagination?: PageableParam, filter?: [FilterParam], sort?: [SortParam]  }) => {
    const { q, filter, pagination, sort } = params
    return useGetProcessLogsQuery({ context: getContext(token), variables: { pagination, q, filter, sort } })
}

export const useRackPerZone = (token: string | undefined, params: { q?: string, zone: string}) => {
    const { q, zone } = params
    return useRacksQuery({ context: getContext(token), variables: { zone, q } })
}

export const useCustomerGroups = (token: string | undefined) => {
    return useGetCustomerGroupsQuery({ context: getContext(token), variables: {} })
}

export const useGetTenants = (token: string | undefined) => {
    return useGetTenantsQuery({ context: getContext(token), variables: {} })
}
